module.exports = __webpack_public_path__ + "static/media/frog.8b6ca2fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/frog.png
// module id = 157
// module chunks = 0